import { Layout, Button } from "antd";
import Sidebar from "./Sidebar";
import HeaderBar from "./HeaderBar";
import { Outlet } from "react-router-dom";
import { CustomerProvider } from "../../store/customerContext";
import { UserProvider } from "../../store/userContext";
import { OrderProvider } from "../../store/orderContext";
import { CityProvider } from "../../store/cityContext";
import { RoleProvider } from "../../store/roleContext";
import { DashboardProvider } from "../../store/dashboardContext";
import CalculatorModal from "../Calculator/CalculatorModal";
import { useState } from "react";

const { Content } = Layout;

const MainLayout: React.FC = () => {
  const [calcOpen, setCalcOpen] = useState(false);

  return (
    <div id="main-app-container"> {/* <--- This line is important! */}
      <Layout
        style={{ minHeight: "100vh" }}
        dir={
          localStorage.getItem("i18nextLng") === "ar" ||
          localStorage.getItem("i18nextLng") === "ckb"
            ? "rtl"
            : "ltr"
        }
      >
        <UserProvider>
          <DashboardProvider>
            <RoleProvider>
              <CustomerProvider>
                <OrderProvider>
                  <CityProvider>
                    <Sidebar />
                    <Layout>
                      <HeaderBar />
                      <Content
                        style={{
                          margin: "24px 16px",
                          padding: 24,
                          background: "#fff",
                        }}
                      >
                        <Outlet />
                      </Content>
                    </Layout>
                    {/* Floating Calculator Button */}
                    <Button
                      style={{
                        position: "fixed",
                        bottom: 40,
                        right: 40,
                        zIndex: 1200, // Make sure this is above sidebars and overlays
                        borderRadius: "50%",
                        width: 56,
                        height: 56,
                        fontSize: 28,
                        background: "#6366f1",
                        color: "white",
                      }}
                      onClick={() => setCalcOpen(true)}
                      type="primary"
                    >
                      🧮
                    </Button>
                    {/* If CalculatorModal is antd Modal: */}
                    <CalculatorModal
                      visible={calcOpen}
                      onClose={() => setCalcOpen(false)}
                      getContainer={() => document.getElementById('main-app-container') as HTMLElement}
                    />
                  </CityProvider>
                </OrderProvider>
              </CustomerProvider>
            </RoleProvider>
          </DashboardProvider>
        </UserProvider>
      </Layout>
    </div>
  );
};

export default MainLayout;
